import React, { FC } from 'react';

import { Grid } from '@mui/material';

import { PaymentPlans } from '@pharmaplan/common';

import PlanBlock from './PlanBlock';

const { basic, unlimited } = PaymentPlans;
interface IPaymentPlanBlock {
  paymentPlan: PaymentPlans;
  setPaymentPlan: React.Dispatch<React.SetStateAction<PaymentPlans>>;
}

const PaymentPlanBlock: FC<IPaymentPlanBlock> = ({
  paymentPlan,
  setPaymentPlan,
}) =>
  (
    <Grid container>
      <PlanBlock
        planType={basic}
        setPaymentPlan={setPaymentPlan}
        selectedPlan={paymentPlan}
        showRadio
      />
      <PlanBlock
        planType={unlimited}
        setPaymentPlan={setPaymentPlan}
        selectedPlan={paymentPlan}
        showRadio
      />
    </Grid>
  );

export default PaymentPlanBlock;
